<template>
  <div id='goodsdetail'>
         <NavTop title="商品详情"></NavTop>   
        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
              <van-swipe-item v-for='item in goodsslide' :key='item.id'>
                  <img :src="item.img" class='slideimg'/>
              </van-swipe-item>
        </van-swipe>

        <div class='goodspanel haspad'>
            <div class='title'>{{goodsinfo.name}}</div>
            <div class='subtitle'>{{goodsinfo.desc}}</div>
            <div class='priceline'>
                <div class='mainprice'>¥{{goodsinfo.nowprice}}</div>
                <div class='dashprice'>¥{{goodsinfo.dashprice}}</div>          
            </div>
        </div>  

         <div class='goodspanel mtop'>
            <div class='title pad4'>商品详情</div>
            <div class='goodscontent'>
                <img v-for="(img,index) in goodscontent" v-lazy="img" class='gimg' :key='index'/>
            </div>
        </div>    
        <ShopCart tip='全场满99包邮' btntext='立即购买'>
            <div class="cartgoodspanel">
                  <div class="cartgoodstitlecon">
                    <div class="cartgoodstitle">已选商品</div>
                    <!--<div class='cartgoodsdelbtn'><van-icon name="delete-o" size="0.45rem" @click='clearCart'/></div>-->
                  </div>
                  <div>
                     <GoodsItem v-for='item in cartlist' :key='item.id' :goodsitem='item' :minnums='1'/>
                  </div>
            </div> 
        </ShopCart> 
  </div>
</template>
<script>
import { NavBar,Icon , Swipe, SwipeItem,Button,Dialog,Image as VanImage} from 'vant';
import ShopCart from '@/components/shopcart';
import GoodsItem from '@/components/goodsitem';
import NavTop from '@/components/navtop'

export default {
   name: 'index',
   data() {
      return {
           goodsslide:[],
           goodscontent:[]
      }
   }, 
   created(){
        this.$store.commit('INIT_CART')
        this.$store.commit('INIT_ADDRESS')
        this.getList(); 
   },
   watch:{
      "$route"(){
          this.getList(); 
      }
   },
   computed:{
       cartlist(){
           return this.$store.state.cart.cartlist
       },
       basetotal(){
           return this.$store.getters.basetotal(this.$store.state.cart.clicked)
      },
       goodsinfo(){
           return this.$store.state.cart.goodsdetail
       }   
   },
   methods: {
      getList(){
           let goodsid=this.$route.params.goodsid
           this.$post("/goods/getGoodsDetail",{goodsid:goodsid}).then((data)=>{
               if(data.result.success){
                  this.goodsslide=data.result.info.slides
                  this.goodscontent=data.result.info.goodscontent
                  this.$store.commit('INIT_GOODSDETAIL',{goodsdetail:data.result.info.goodsinfo}) 
                  this.$store.commit('INIT_LEVELUPMONEY',{levelupmoney:data.result.info.levelupmoney})
                  this.addToCart()
               }else{
                  this.$toast(data.result.info)
               }
           })
      },
      addToCart(){
           this.$store.commit('ADD_TO_CART',{goodsItem:this.goodsinfo})
           this.$store.commit('UPDATE_NOWPRICE',{total:this.basetotal,pricelevel:this.goodsinfo.pricelevel}) 
      },
      clearCart(){
             Dialog.confirm({
                title: '清空购物车',
                message: '您确定要清空当前购物车内容吗？',
                })
                .then(() => {
                   this.$store.commit('INIT_CART') 
                })
                .catch(() => {
                   Dialog.close	
                });
      }
   },
   components: {
        [NavBar.name]: NavBar,
        [Icon.name]: Icon,
        [Swipe.name]: Swipe,
        [SwipeItem.name]: SwipeItem,
        [Button.name]: Button,
        [Dialog.Component.name]: Dialog.Component,
        [VanImage.name]:VanImage,
        ShopCart,
        GoodsItem,
        NavTop
   }
}
</script>
<style scoped>
#goodsdetail{background-color:#F6F6F6;min-height: 100vh;padding-bottom: 80px;}
::v-deep .van-search{position:fixed;width:100%;top:0;left:0;}
::v-deep .van-field__right-icon{display:flex;}
::v-deep [class*=van-hairline]::after{border: none;}
.my-swipe .van-swipe-item {color: #fff;text-align: center;}
.goodspanel{text-align: left;background-color: #ffffff;}
.haspad{padding: 0.2rem;}
.mtop{margin-top:0.2rem;}
.pad4{padding-left: 0.4rem!important;}
.title{text-align: left;font-size: 0.42rem;padding: 0.2rem;}
.subtitle{text-align: left;color:#bbbbbb;padding: 0 0.2rem;}
.priceline{display: flex;align-items: center;padding: 0.2rem;}
.label{flex:1;align-self: flex-start;color:#cccccc;}
.description{flex:4;}
.mainprice{font-size:0.6rem;color:#CB0930;}
.dashprice{font-size: 0.3rem;text-decoration: line-through;color:#cccccc;padding: 0.2rem;}
.btncart{margin-left:auto;}
.goodspromotion{display: flex;flex-wrap: wrap;padding-bottom: 85px;}
::v-deep .shopshowitem-container{flex:1 0 45%;}
::v-deep .shopshow-items{overflow: hidden;flex-wrap: wrap;}
::v-deep .shopshowImg{width:100%;height:100%;}
.cartgoodspanel{display: flex;flex-flow: column nowrap;}
.cartgoodstitlecon{display: flex;}
.cartgoodstitle{font-size:0.4rem;font-weight: 600p;}
.cartgoodsdelbtn{margin-left: auto;}
.slideimg{margin: 0;padding: 0;width:100%;}
.gimg{display: block;}
</style>